/**
 * Route path constants — introduced for the Stripe migration so the payment
 * flows navigate via typed constants instead of magic strings. Seeded with the
 * new Stripe routes plus the existing payment/subscription routes this migration
 * touches. Not a full app-wide route migration — grow it per milestone.
 */
export const ROUTES = {
  // New Stripe routes (M4/M5)
  STRIPE_ADD_CARD: "/stripe/add-card",
  STRIPE_ONBOARDING: "/stripe/onboarding",
  // Stripe Connect return target (the backend account-link return_url points
  // here); redirects to the onboarding screen so its status poll runs.
  STRIPE_RETURN: "/stripe/return",
  // Connect refresh_url target. Account Links are single-use, so Stripe sends
  // anyone holding an expired or already-opened one here rather than to
  // return_url — a separate route because it means the opposite thing: not
  // "back from setup" but "never got there". Mints a fresh link.
  STRIPE_REFRESH: "/stripe/refresh",
  // 1099 tax documents (Connect embedded components). Also the URL configured
  // in Stripe's Connect Site links, so it is what the pre-filing and delivery
  // emails link to — and what mobile opens in the system browser. Changing it
  // means re-validating those settings in the Dashboard.
  STRIPE_TAX_DOCUMENTS: "/stripe/tax-documents",

  // Existing payment/subscription routes the migration re-points
  SUBSCRIPTION: "/subscription",
  PAYMENT_OPTIONS: "/payment-options",
  WALLET: "/wallet",
  CONTRACT_DETAILS: "/contract-details",
  CONTRACT_LISTS: "/contract-lists",

  // Legacy AeroPay/Everee routes (retired as each Stripe screen lands)
  GET_PAYMENTS: "/get-payments",
  BANK_INFO: "/bank-info",
  BANK_ACCOUNTS: "/bank-accounts",
  ADD_HOM_ACCOUNT: "/add-hom-account",
};
